import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

export const useChangeCapabilityStatus = (options = {}) => {
  const res = useMutation(
    (dto) =>
      http.put(HTTP_ENDPOINTS.sunbit.updateCapabilityStatus(dto.clinicId), {
        is_sunbit_enabled: dto.isSunbitEnabled,
      }),
    { ...options },
  );
  return res;
};
